module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'DakejianApply',
        query: {}
      }),
      expression: "{name:'DakejianApply',query:{}}"
    }],
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230425/user-0/20230425/a1bd4950e71614d8d809ed975938d3a0.jpeg?x-oss-process=style/tb-750"
    }
  })]), _vm._v(" "), (!_vm.isStepTwo) ? _c('van-form', {
    staticClass: "step-one",
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "name": "radio",
      "label": "活动",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.leixing),
            callback: function($$v) {
              _vm.$set(_vm.formData, "leixing", $$v)
            },
            expression: "formData.leixing"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "2023年‘奔跑吧·少年’全国啦啦操大课间展示活动"
          }
        }, [_vm._v("2023年‘奔跑吧·少年’全国啦啦操大课间展示活动")])], 1)]
      },
      proxy: true
    }], null, false, 2125736883)
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "单位类型",
      "rules": [{
        required: true,
        message: '请选择单位类型'
      }],
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.type),
            callback: function($$v) {
              _vm.$set(_vm.formData, "type", $$v)
            },
            expression: "formData.type"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "大学"
          }
        }, [_vm._v("大学")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "中学"
          }
        }, [_vm._v("中学")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "小学"
          }
        }, [_vm._v("小学")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "幼儿园"
          }
        }, [_vm._v("幼儿园")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "其他"
          }
        }, [_vm._v("其他")])], 1)]
      },
      proxy: true
    }], null, false, 2366942419)
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入准确的单位全称'
      }],
      "label": "单位名称",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入准确的单位全称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入详细地址'
      }],
      "error-message-align": "right",
      "label": "详细地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入邮寄联系人及电话'
      }],
      "error-message-align": "right",
      "label": "邮寄联系人及电话",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入邮寄联系人及电话"
    },
    model: {
      value: (_vm.formData.express_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "express_name", $$v)
      },
      expression: "formData.express_name"
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("啦啦操推广大使")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入姓名'
      }],
      "error-message-align": "right",
      "label": "个人姓名（限1人）",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("联系人信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入联系人姓名'
      }],
      "error-message-align": "right",
      "label": "联系人姓名",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入联系人姓名"
    },
    model: {
      value: (_vm.formData.contactsname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contactsname", $$v)
      },
      expression: "formData.contactsname"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入联系人手机'
      }],
      "error-message-align": "right",
      "label": "联系人手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入联系人手机"
    },
    model: {
      value: (_vm.formData.contactsphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contactsphone", $$v)
      },
      expression: "formData.contactsphone"
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("加群二维码")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "80%",
      "text-align": "center",
      "margin": "0px auto 20px",
      "font-size": "14px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230429/user-0/20230429/e19b2f59f724ae09aa7db37bccd95495.png"
    }
  }), _vm._v(" "), (!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "native-type": "button",
      "round": ""
    }
  }, [_vm._v("请长按图片保存")]) : _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "native-type": "button",
      "color": "",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下载二维码\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'DakejianApplyList'
      }),
      expression: "{name: 'DakejianApplyList'}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "native-type": "button",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("\n          申报列表\n        ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": true,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("\n          申报已截止\n        ")])], 1)], 1) : _c('van-form', {
    staticClass: "step-two",
    on: {
      "submit": _vm.onSubmitThree,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("全国校园大课间啦啦操优秀参与奖")]), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "bottom": "80px",
      "right": "10px",
      "z-index": "10",
      "position": "fixed"
    },
    attrs: {
      "native-type": "button",
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showTemplate = true
      }
    }
  }, [_vm._v("导入模板\n    ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        提交申请\n      ")])], 1)], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "导入模板信息"
    },
    model: {
      value: (_vm.showTemplate),
      callback: function($$v) {
        _vm.showTemplate = $$v
      },
      expression: "showTemplate"
    }
  }, [_c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("复制下面的链接，用电脑端打开，进行批量导入操作")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.row.share),
      expression: "row.share",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "operate-desc-left",
    staticStyle: {
      "color": "#666"
    }
  }, [_vm._v("导入模板链接地址：" + _vm._s(_vm.row.share) + "\n      "), _c('div', {
    staticClass: "small-button"
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('DakejianDanweiPicker', {
    attrs: {
      "show": _vm.showDanweiPicker,
      "limit": 1,
      "value": _vm.formData.extra_danwei,
      "defaultValue": _vm.formData.extra_danwei
    },
    on: {
      "onChange": _vm.onDanweiChange,
      "onClose": function($event) {
        _vm.showDanweiPicker = false
      },
      "onConfirm": _vm.onDanweiConfirm
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-372dc71f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/dakejian/DakejianApply.vue
// module id = 2323
// module chunks = 0